/**
 * Bill Credits Reducer
 */
import { fromJS } from 'immutable';
import Constants from '../../constants';

const { BillCredit, BillCredits } = Constants;

const initialState = fromJS({
  loading: false,
  error: null,
  billCredits: [],
  billCredit: {},
  count: 0,
});

/**
 * Returns and sets the next state based on the action passed to it
 * @param {object} state state object that defaults to the initial state
 * @param {object} action action object containing action type and payload properties
 */
const billCreditsReducer = (state = initialState, action) => {
  const { count, error, billCredits, billCredit } = action;

  switch (action.type) {
    case BillCredits.GET_BILL_CREDITS:
      return state.set('loading', true);
    case BillCredits.GET_BILL_CREDITS_ERROR:
      return state.set('loading', false).set('error', error);
    case BillCredits.GET_BILL_CREDITS_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('billCredits', fromJS(billCredits))
        .set('count', count);
    case BillCredit.GET_BILL_CREDIT:
      return state.set('loading', true);
    case BillCredit.GET_BILL_CREDIT_ERROR:
      return state.set('loading', false).set('error', error);
    case BillCredit.GET_BILL_CREDIT_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('billCredit', fromJS(billCredit));
    default:
      return state;
  }
};

export default billCreditsReducer;
